/*!
 * Copyright © 2018. Verizon Connect Ireland Limited. All rights reserved.
 */

import { IPlaceMapCategory, IWorkOrderAdvancedOptions } from '../../models';

export interface IAdvancedOptionsState {
  placeMapCategories: IPlaceMapCategory[];
  placeCategoryIds: number[];
  garminStopStatusesIdsSelected: number[];
  workOrderAdvancedOptions: IWorkOrderAdvancedOptions;
}

export const initialAdvancedOptionsState: IAdvancedOptionsState = {
  placeMapCategories: [],
  placeCategoryIds: null,
  garminStopStatusesIdsSelected: null,
  workOrderAdvancedOptions: null
};
